import React from 'react';

const ShopTagCard = ({ settings, onChange }) => (
  <div className="bg-white rounded-xl shadow p-6">
    <h3 className="font-semibold mb-4">店铺标语</h3>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div>
        <label className="block text-sm font-medium mb-1">中文</label>
        <input type="text" value={settings.shop_tag}
          onChange={e => onChange('shop_tag', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          placeholder="台灣食品專賣店" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">英文</label>
        <input type="text" value={settings.shop_tag_en}
          onChange={e => onChange('shop_tag_en', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          placeholder="Taiwan Food Specialty" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">高棉语</label>
        <input type="text" value={settings.shop_tag_km}
          onChange={e => onChange('shop_tag_km', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500" />
      </div>
    </div>
  </div>
);

export default ShopTagCard;